import { Helmet } from "react-helmet-async";

type Props = {
  title?: string;
  description?: string;
  canonical?: string;
  image?: string | null;
  socialTitle?: string;
  socialDescription?: string;
  socialImage?: string | null;
  structuredData?: Record<string, unknown> | null;
  type?: "website" | "article";
  robots?: string;
};

export function Seo({ title = "ZimSmart", description = "Your source for smarter living in Zimbabwe.", canonical, image, socialTitle, socialDescription, socialImage, structuredData, type = "website", robots = "index,follow,max-image-preview:large" }: Props) {
  const shareTitle = socialTitle || title;
  const shareDescription = socialDescription || description;
  const shareImage = socialImage || image;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      <meta name="robots" content={robots} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="ZimSmart" />
      <meta property="og:title" content={shareTitle} />
      <meta property="og:description" content={shareDescription} />
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      {shareImage ? <meta property="og:image" content={shareImage} /> : null}
      {shareImage ? <meta property="og:image:secure_url" content={shareImage} /> : null}
      {shareImage ? <meta property="og:image:type" content="image/jpeg" /> : null}
      {shareImage ? <meta property="og:image:width" content="1200" /> : null}
      {shareImage ? <meta property="og:image:height" content="630" /> : null}
      {shareImage ? <meta property="og:image:alt" content={shareTitle} /> : null}
      <meta name="twitter:card" content={shareImage ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={shareTitle} />
      <meta name="twitter:description" content={shareDescription} />
      {shareImage ? <meta name="twitter:image" content={shareImage} /> : null}
      {structuredData ? (
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      ) : null}
    </Helmet>
  );
}
